"use client";

import Image from "next/image";
import {
  AppBar,
  Box,
  Container,
  Grid,
  Link,
  Toolbar,
  Typography,
} from "@mui/material";

import { useUi } from "@/context/util/ui";

import SignInSignOutButton from "@/components/signInSignOut";

export default function NavBar() {
  const { metadata } = useUi();
  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <AppBar position="static">
        <Toolbar>
          <Container sx={{ display: "flex" }}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              flexWrap="nowrap"
              width="100%"
            >
              <Grid
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                <Link
                  className="logo"
                  lineHeight="0.7"
                  href="https://www.morainepark.edu"
                  color="inherit"
                  variant="h6"
                >
                  <Image
                    alt="Moraine Park Technical College Logo"
                    src="/account-utilities/logo.png"
                    width="192"
                    height="32"
                    priority={true}
                  />
                </Link>
                <Link
                  className="smallLogo"
                  sx={{ display: "flex" }}
                  href="https://www.morainepark.edu"
                  color="inherit"
                >
                  <Image
                    alt="Moraine Park Technical College Logo"
                    src="/account-utilities/small-logo.png"
                    width="50"
                    height="32"
                    priority={true}
                  />
                </Link>
                <Link
                  ml={4}
                  sx={{
                    alignItems: "center",
                    display: "flex",
                    textDecoration: "none",
                  }}
                  href={`/account-utilities${metadata.url}`}
                  color="inherit"
                  variant="h6"
                >
                  <Typography
                    variant="button"
                    component="h1"
                    sx={{ fontWeight: "bold" }}
                  >
                    {metadata.title}
                  </Typography>
                </Link>
              </Grid>
              <Grid
                ml="auto"
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                {metadata.url === "/help-desk/search" ? (
                  <Link
                    mr={2}
                    ml={2}
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      textDecoration: "none",
                    }}
                    href={`/account-utilities/help-desk/reports/exceptions`}
                    color="inherit"
                    variant="button"
                    fontSize={12}
                  >
                    Exceptions Report
                  </Link>
                ) : null}
                {metadata.needsAuth ? <SignInSignOutButton /> : null}
              </Grid>
            </Grid>
          </Container>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
